import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TransactionService } from './transaction.service';
/**
 * Always allows navigation and refreshes plan credits when entering a credits-gated route, so a
 * balance topped up by an admin or changed elsewhere (another tab, a team plan change) shows up
 * without a full page refresh. Always calls the API - no caching, every entry into one of these
 * routes shows the current balance.
 * Attach to the specific leaf route whose component displays/depends on plan credits; don't rely on
 * parent guards for child/tab navigation (see the settings route's own comment on this tradeoff).
 */
@Injectable({
  providedIn: 'root'
})
export class CreditsRefreshGuard {
  constructor(private transactionService: TransactionService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
      this.transactionService.updateAllCreditsForCurrentUser().subscribe();
      return true;
  }
}
